import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { UserService } from 'src/app/_services';
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { CompanyService } from '../company/company.service';
import { ReportService } from '../report/report.service';
import { GuestReportService } from './guest-report/guest-report.service';

@Component({
  selector: 'app-administrator',
  templateUrl: './administrator.page.html',
  styleUrls: ['./administrator.page.scss'],
})
export class AdministratorPage implements OnInit {

  page: string = "guestReport";
  defaultPage: string = "guestReport";

  headerInit: HeaderModel = {
    segmentsChangeFunc: ($event) => this.segmentChanged($event),
    userSettingsBreakpoint: 1050,
    segments: [
      {
        name: "ADMIN.GUEST_REPORT.HEADER",
        value: "guestReport",
        permissionKeys: ["administrator.guest-report-view"],
      },
      {
        name: "ADMIN.SUBMISSION.HEADER",
        value: "submissionsReport",
        permissionKeys: ["administrator.submissions-report-view"],
      },
      {
        name: "ADMIN.PARKING.HEADER",
        value: "parkingReport",
        permissionKeys: ["administrator.parking-report-view"],
      },
    ],
    title: "ADMIN.HEADER",
  };
  
  constructor(
    public translateService: TranslateService,
    public companyService: CompanyService,
    public userServ: UserService,
    public p: ThisPlatform,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public guestReportServ: GuestReportService,
    private headerServ: HeaderService,
    public reportServ: ReportService,

  ) { }

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(
      (params) => {
        if (params.get("section")) {
          this.page = params.get("section");
          this.setQueryParam(this.page);

          if (this.page === "guestReport") {
            this.chartVariablesLoad();
          }
        } else {
          this.setDefaultPage();
          this.chartVariablesLoad();
          // this.page = this.defaultPage;
          this.headerServ.setHeaderInit(this.headerInit);
        }
        this.userServ.lastSegment = this.page;
      });
    }
    
    ionViewWillEnter() {
    this.headerInit.activeSegment = this.page;
    this.headerServ.setHeaderInit(this.headerInit);

    if (this.page === "guestReport") {
      this.chartVariablesLoad();
      this.guestReportServ.reloadFilter();
      this.guestReportServ.refreshChart(this.guestReportServ.guestReports);
      this.guestReportServ.loadChart(
        this.guestReportServ.enter,
        this.guestReportServ.leave,
        this.guestReportServ.date,
      );
    }
  }

  segmentChanged(event: any) {
    this.page = event.detail.value;
    this.setQueryParam(this.page);
    this.userServ.lastSegment = this.page;
  }

  setQueryParam(value) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { section: value },
      queryParamsHandling: "merge",
    });
  }

  ionViewWillLeave() {
    this.guestReportServ.actualSubscription.unsubscribe();
    this.reportServ.actualSubscription.unsubscribe();

    this.reportServ.reportFilter = {
      statusValue: "null",
      status: null,
      priorityValue: "null",
      priority: null,
    };

    this.page = null;
  }

  chartVariablesLoad() {
    this.guestReportServ.defaultLocale = this.userServ.getDefaultLanguage();
    this.guestReportServ.chartHeader = this.translateService.instant("ADMIN.GUEST_REPORT.HEADER");
    this.guestReportServ.entires = this.translateService.instant("ADMIN.GUEST_REPORT.ENTRY_QUANTITY");
    this.guestReportServ.exits = this.translateService.instant("ADMIN.GUEST_REPORT.EXIT_QUANTITY");
  }

  private async setDefaultPage() {
    if(await this.userServ.hasRolesAsync(["administrator.guest-report-view"])) {
      this.page = "guestReport";
      this.defaultPage = "guestReport";
      return;
    }

    if(await this.userServ.hasRolesAsync(["administrator.submissions-report-view"])) {
      this.page = "submissionsReport";
      this.defaultPage = "submissionsReport";
      return;
    }

    if(await this.userServ.hasRolesAsync(["administrator.parking-report-view"])) {
      this.page = "parkingReport";
      this.defaultPage = "parkingReport";
      return;
    }
  }

}